import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

const PrivacyPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Privacy Policy</title>
      </Helmet>

      <div className="min-h-screen bg-background">
        <Header />

        <main className="pt-20">
          <section className="py-16 lg:py-20 bg-gradient-to-br from-primary via-secondary to-primary">
            <div className="container mx-auto px-4">
              <h1 className="text-4xl lg:text-5xl font-headline font-bold text-white text-center">
                Privacy Policy
              </h1>
            </div>
          </section>

          <section className="py-12 lg:py-16">
            <div className="container mx-auto px-4">
              <div className="max-w-4xl mx-auto bg-card border border-border rounded-2xl p-6 lg:p-10 space-y-8">
                <div className="space-y-3 text-foreground">
                  <h2 className="text-2xl font-headline font-semibold">Ownership</h2>
                  <p className="text-base leading-7 text-muted-foreground">
                    The fitwr application is owned and operated by KZ KHAB (business portfolio: jetu.app). This policy covers data processing for our digital services and products, including kzhub.kz.
                  </p>
                </div>

                <div className="space-y-3 text-foreground">
                  <h2 className="text-2xl font-headline font-semibold">Meta Portfolio Information</h2>
                  <ul className="space-y-2 text-base leading-7 text-muted-foreground">
                    <li>Registered Business Name: KZ KHAB</li>
                    <li>Business Portfolio Name: jetu.app</li>
                    <li>Application Name: fitwr</li>
                    <li>Website in Meta: https://kzhub.kz/</li>
                    <li>Contact Email: info@ai.jetu.pro</li>
                  </ul>
                </div>

                <div className="space-y-3 text-foreground">
                  <h2 className="text-2xl font-headline font-semibold">Instagram API</h2>
                  <p className="text-base leading-7 text-muted-foreground">
                    fitwr accesses Instagram messages via the Meta Graph API to provide automated support for KZ KHAB customers.
                  </p>
                </div>

                <div className="space-y-3 text-foreground">
                  <h2 className="text-2xl font-headline font-semibold">Data Deletion</h2>
                  <p className="text-base leading-7 text-muted-foreground">
                    To request data deletion, contact info@ai.jetu.pro. Requests are processed within 48 hours.
                  </p>
                </div>
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default PrivacyPolicy;
